{
  "days": {
    "Monday": "星期一",
    "Tuesday": "星期二",
    "Wednesday": "星期三",
    "Thursday": "星期四",
    "Friday": "星期五",
    "Saturday": "星期六",
    "Sunday": "星期天"
  },
  "months": {
    "January": "1",
    "February": "2",
    "March": "3",
    "April": "4",
    "May": "5",
    "June": "6",
    "July": "7",
    "August": "8",
    "September": "9",
    "October": "10",
    "November": "11",
    "December": "12"
  },
  "actions": {
    "StartReading": "开始阅读",
    "PreviewEdition": "Preview Edition",
    "Download": "下载",
    "Retry": "重试",
    "ReadePaper": "阅读电子报",
    "TryAgain": "请重试"
  },
  "preview": {
    "bottomBar": {
      "subscribe": "Learn about subscription",
      "login": "Already a subscriber? Log in"
    },
    "gate": {
      "title": "Subscribe to view the archive",
      "body": "Subscribers get the full edition, offline reading and sharing, plus archive access.",
      "cta": "Learn about subscription"
    }
  },
  "multiTitle": {
    "st": "",
    "zb": "联合早报",
    "bh": "",
    "tm": "தமிழ் முரசு",
    "sm": "新明日报",
    "bt": "",
    "bm" : "",
    "mm" : "",
    "tabla": "Tabla!"
  },
  "tooltip": {
    "Logout": "退出",
    "Onboarding": "小贴士",
    "CalenderView": "日历视图",
    "TileView": "封面视图",
    "StartReading": "点击阅读"
  },
  "nav": {
    "Logout": "登出",
    "Calendar": "日历",
    "Archive": "往期报纸"
  }
}
